<style>
    .mat-column-openOrder {
        flex: 0 0 80px;
    }

    .mat-column-OnRentDate {
        flex: 0 0 150px;
    }

    .mat-column-OffRentDate {
        flex: 0 0 150px;
    }

    .mat-column-EndContract {
        flex: 0 0 50px;
    }

    .mat-column-RegNo, .mat-column-DLLContractId, .mat-column-XalAccountNo, .mat-column-ContractType, .mat-column-OwnerId {
        flex: 0 0 80px;
    }

    .expired {
        color: #e52a16;
        background: rgba(229,42,22,0.2);
    }
</style>
<t4-header icon="glyphicon-stats" title="{{'TO.Dashboard.Headline' |translate : 'Dashboard' }}">
    <button mat-button color="primary" matTooltip="{{ 'TO.Dashboard_cmdNewOrder' | translate:'New Order'}}" [routerLink]="['/TurboOrder/Order/0']"><mat-icon>note_add</mat-icon><span>{{ 'TO.Dashboard_cmdNewOrder' | translate:'New Order'}}</span></button>
</t4-header>
<div class="row">
    <div class="col-md-3">
        <t4-kpi kpiId="ExpiredContracts" database="TurboOrder" title="{{'Turbo.Dashboard.ExpiredContracts' | translate : 'Expired contracts' }}"></t4-kpi>
    </div>
    <div class="col-md-3">
        <t4-kpi kpiId="SalesCount" database="TurboOrder" title="{{'Turbo.Dashboard.SalesCount' | translate : 'Ready for invoicing' }}"></t4-kpi>
    </div>
    <div class="col-md-3">
        <t4-kpi kpiId="TransportCount" database="TurboOrder" title="{{'Turbo.Dashboard.TransportCount' | translate : 'In storage' }}"></t4-kpi>
    </div>
    <div class="col-md-3">
        <t4-kpi kpiId="NoAction" database="TurboOrder" title="{{'Turbo.Dashboard.NoAction' | translate : 'Terminated without action' }}"></t4-kpi>
    </div>
</div>
<br/><br/>
     <mat-tab-group>
       <mat-tab label="{{'TO.Dashboard.Headline' |translate : 'Dashboard' }}">
         <div class="row">
           <div class="col-md-6 widget"><dbwidget-order-flow title="{{ 'TO.OrderFlowWidget_Headline' | translate : 'Order flow'}}"></dbwidget-order-flow></div>
           <div class="col-md-6 widget"><dbwidget-expiring-contracts title="{{ 'TO.ExpiringContractsWidget_Headline' | translate : 'Expiring contracts'}}"></dbwidget-expiring-contracts></div>
           <div class="col-xs-12"><t4-data-table apiMethod="TurboOrder/GetOrdetStatusStats" headline="{{ 'TO.Widget.StatusStats.Headline' | translate : 'Order status overview' }}" matSort></t4-data-table></div>
         </div>
       </mat-tab>
       <mat-tab label="{{'TO.Dashboard.Unhandled' |translate : 'Unhandled expiring contracts' }}">
         <button (click)="createTermination()" mat-raised-button id="cmdTerminate" style="margin: 15px;" type="button" [disabled]="!anyChecked()">{{ 'TO_ActiveContracts_Terminate_cmdTerminateContracts' | translate : 'Terminate' }}</button>
         <t4-container>
           <t4-data-table #tblUnhandled apiMethod="/TurboOrder/GetUnhandledExpiringContracts" [autoGenerateColumns]="false" headline="{{'TO.Trailers_ExpiringContracts' | translate : 'Unhandled expiring contracts' }}" matSort matSortActive="OffRentDate" matSortDirection="asc" [filterFields]="['RegNo', 'OwnerId', 'DeliveryAddressCustomerName', 'DeliverAddress', 'XALAccountNo']">
             <ng-container matColumnDef="openOrder">
               <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">
                 <a class="createSchedule" matTooltip="{{ 'Turbo.Core.ContractsHistory.Table_OpenOrder' | translate : 'Open order' }}">
                   <mat-icon>search</mat-icon>
                 </a>
               </mat-cell>
             </ng-container>
             <ng-container matColumnDef="EndContract">
               <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }">
                 <mat-checkbox [(ngModel)]="row.Terminate" name="rdbTerminate{{row.Id}}"></mat-checkbox>
               </mat-cell>

             </ng-container>
             <ng-container matColumnDef="XalAccountNo">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_XalAccountNo' | translate : 'Location id' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{row.XalAccountNo}}</mat-cell>

             </ng-container>
             <ng-container matColumnDef="DeliveryAddressCustomerName">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_CustomerAddressDeliveryName' | translate : 'Customer' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{row.DeliveryAddressCustomerName}}</mat-cell>

             </ng-container>
             <ng-container matColumnDef="DeliveryAddress">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_CustomerDeliveryAddress' | translate : 'Address' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{row.DeliveryAddress}}</mat-cell>

             </ng-container>
             <ng-container matColumnDef="RegNo">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_RegNo' | translate : 'Reg. no.' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{ row.RegNo }}</mat-cell>

             </ng-container>
             <ng-container matColumnDef="Alias">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_Model' | translate : 'Model' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{ row.Alias }}</mat-cell>
             </ng-container>
             <ng-container matColumnDef="OnRentDate">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_OnRentDate' | translate : 'Start date' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{row.OnRentDate | date: 'yyyy-MM-dd'}}kr</mat-cell>

             </ng-container>
             <ng-container matColumnDef="OffRentDate">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_OffRentDate' | translate : 'End date' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{row.OffRentDate | date: 'yyyy-MM-dd'}}</mat-cell>

             </ng-container>
             <ng-container matColumnDef="DLLContractId">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_DllContractId' | translate : 'DLL number' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{row.DLLContractId}}</mat-cell>

             </ng-container>
             <ng-container matColumnDef="ContractType">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_ContractType' | translate : 'Contract type' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{'TO_Order_OrderType' + row.ContractType | translate }}</mat-cell>

             </ng-container>
             <ng-container matColumnDef="OwnerId">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_OwnerId' | translate : 'Owner' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" [ngClass]="{ expired: row.OffRentDate <= today }" (click)="openContractDialog(row.VehicleId)">{{row.OwnerId}}</mat-cell>

             </ng-container>
           </t4-data-table>
         </t4-container>
         <button (click)="createTermination()" mat-raised-button id="cmdTerminate" style="margin: 15px;transform: translateY(-60px);" type="button" [disabled]="!anyChecked()">{{ 'TO_ActiveContracts_Terminate_cmdTerminateContracts' | translate : 'Terminate' }}</button>
       </mat-tab>
       <mat-tab label="{{ 'TO.ActiveContracts.tabStock' | translate:'Used stock'}}">
         <t4-container>
           <t4-data-table #tblUsedStock apiMethod="TurboOrder/GetUsedStockTrailers" [autoGenerateColumns]="false" headline="{{'TO.Trailers_NoUsedStocks' | translate : 'No used stocks' }}" matSort matSortActive="TerminateAt" matSortDirection="asc" [filterFields]="['RegNo', 'SerialNo', 'ArtNo']">
             <ng-container matColumnDef="openOrder">
               <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">
                 <a class="createSchedule" matTooltip="{{ 'Turbo.Core.ContractsHistory.Table_OpenOrder' | translate : 'Open order' }}">
                   <mat-icon>search</mat-icon>
                 </a>
               </mat-cell>
               <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
             </ng-container>
             <ng-container matColumnDef="TerminationId">
               <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
               <mat-cell *matCellDef="let row">
                 <span *ngIf="row.TerminationId" (click)="showTermination(row.TerminationId)"><mat-icon>launch</mat-icon></span>
               </mat-cell>
             </ng-container>
             <ng-container matColumnDef="XalAccountNo">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_XalAccountNo' | translate : 'Location id' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{row.XalAccountNo}}</mat-cell>
             </ng-container>
             <ng-container matColumnDef="DeliveryAddressCustomerName">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_CustomerAddressDeliveryName' | translate : 'Customer' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{row.DeliveryAddressCustomerName}}</mat-cell>
             </ng-container>
             <ng-container matColumnDef="DeliveryAddress">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_CustomerDeliveryAddress' | translate : 'Address' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{row.DeliveryAddress}}</mat-cell>
             </ng-container>
             <ng-container matColumnDef="RegNo">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_RegNo' | translate : 'Reg. no.' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{ row.RegNo }}</mat-cell>
               <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
             </ng-container>
             <ng-container matColumnDef="SerialNo">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_SerialNo' | translate : 'Serial no.' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{ row.SerialNo }}</mat-cell>
               <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
             </ng-container>
             <ng-container matColumnDef="ArtNo">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_ArtNo' | translate : 'Article no.' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{ row.ArtNo }}</mat-cell>
               <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
             </ng-container>
             <ng-container matColumnDef="ArtDescription">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_ArtDescription' | translate : 'Article name' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{ row.ArtDescription }}</mat-cell>
               <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
             </ng-container>
             <ng-container matColumnDef="ManufacturingDate">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_ManufacturingDate' | translate : 'Manufacturing date' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{ row.ManufacturingDate | date : 'yyyy-MM-dd' }}</mat-cell>
               <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
             </ng-container>
             <ng-container matColumnDef="Comment">
               <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.ActiveContracts.Terminate_Trailer_LastComment' | translate : 'Last comment' }}</mat-header-cell>
               <mat-cell *matCellDef="let row" (click)="openVehicle(row.Id)">{{ row.Comment }}</mat-cell>
               <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
             </ng-container>
           </t4-data-table>
           </t4-container>
          </mat-tab>
     </mat-tab-group>
